import { Location } from "@angular/common";
import { Component, OnInit, ViewEncapsulation } from "@angular/core";

import { ActivatedRoute } from "@angular/router";
import { AccountFinderDialogComponent } from "app/admin/account-finder-dialog.component";
import { Account } from "app/model/entities/entity-model";

import { DbQueryService } from "app/shared/db-query.service";
import { DomainBaseComponent } from "app/shared/domain-base.component";
import { DomainService } from "app/shared/domain.service";
import { EntityFinderDialog } from "app/shared/entity-finder.dialog";
import _ from "lodash";
import { takeUntil } from "rxjs/operators";

interface ChartInfo {
  id: string;
  name: string;
  usesAccount: boolean;
}

@Component({
  selector: "charts-container",
  templateUrl: "./charts-container.component.html",

  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class ChartsContainerComponent
  extends DomainBaseComponent
  implements OnInit
{
  title: string;
  options: any;
  accountId: number;
  account: Account;
  allAccounts: Account[];
  matchingAccounts: Account[];
  charts: ChartInfo[];
  chart: ChartInfo;
  chartId: string;

  constructor(
    protected domainService: DomainService,
    protected route: ActivatedRoute,

    protected location: Location,
    protected dbQueryService: DbQueryService
  ) {
    super(domainService);

    this.route.paramMap.pipe(takeUntil(this.onDestroy)).subscribe(() => {
      this.updateFromContext();
    });
  }

  async updateFromContext() {
    this.chartId = this.route.snapshot.queryParams["chartId"] || "InvoiceStats";

    // const allAccounts = await this.uow.queryAll(Account, 'Accounts');
    // Only get accounts that actually have invoices.
    const allAccounts = await this.dbQueryService.getAccountsWithInvoices();
    this.allAccounts = _.sortBy(allAccounts, (a) => a.accountName);
    this.charts = [
      { id: "InvoiceDelay", name: "Invoice Delay", usesAccount: true },
      { id: "InvoiceStats", name: "Invoice Stats", usesAccount: true },
      {
        id: "ManufInventoryCount",
        name: "Inventory Counts by Manufacturer",
        usesAccount: false,
      },
      {
        id: "JoStats",
        name: "Current Job Orders by Age and Status",
        usesAccount: false,
      },
    ];
    this.chart =
      this.charts.find((c) => c.id == this.chartId) || this.charts[0];
    this.account = null;
    this.isPageReady = true;
  }

  updateLocation() {
    const urlTree = this.router.createUrlTree(["/charts-container"], {
      queryParams: {
        chartId: this.chartId,
      },
    });
    const url = urlTree.toString();
    this.domainService.location.replaceState(url);
  }

  searchAccounts(query: string) {
    this.matchingAccounts = this.allAccounts.filter(
      (a) => a.accountName.toLowerCase().indexOf(query.toLowerCase()) > -1
    );
  }

  getTitle(accountId?: number) {
    const accountName =
      accountId == null
        ? "All accounts"
        : this.allAccounts.find((a) => a.id == accountId)?.accountName;
    return `Invoice Delay Chart - ${accountName} `;
  }

  onChartChange(chart: ChartInfo) {
    this.chartId = chart.id;
    this.updateLocation();
  }

  async selectAccount() {
    const r = await EntityFinderDialog.open(AccountFinderDialogComponent, this);
    if (r.length == 0) return;
    this.account = r[0];
  }

  clearAccount() {
    this.accountId = null;
    this.account = null;
  }

  async canDeactivate() {
    const ok = await super.canDeactivate();
    if (!ok) return false;
    return true;
  }
}
